import { render, staticRenderFns } from "./Spinner.component.vue?vue&type=template&id=a39be2f2&scoped=true&lang=pug"
import script from "./Spinner.component.vue?vue&type=script&lang=ts"
export * from "./Spinner.component.vue?vue&type=script&lang=ts"
import style0 from "./Spinner.component.vue?vue&type=style&index=0&id=a39be2f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a39be2f2",
  null
  
)

export default component.exports